export default class NodeEvent {
    constructor({chain = [], detail, target, type}) {
        this.#chain = chain
        this.#detail = detail
        this.#target = target
        this.#type = type
    }

    get chain() {
        return this.#chain
    }

    get detail() {
        return this.#detail
    }

    get isPropagationStopped() {
        return this.#isPropagationStopped
    }

    get target() {
        return this.#target
    }

    get type() {
        return this.#type
    }

    stopPropagation() {
        this.#isPropagationStopped = true
    }

    #chain
    #detail
    #isPropagationStopped = false
    #target
    #type
}
